import { ICustomerEquipmentModel } from "../../baseInfo/customerEquipmentModel/interfaces";
import { BaseEntityManager } from "../../components/entityManager";
import { IEntityManagerProps, IEntityManagerStates, IInitialData, IMetadata, enmControlType, enmPropertyType } from "../../components/entityManager/interfaces";
import { IFetchingInfo } from "../../components/infrastructure/models";

export interface ICustomerEquipmentModelListProps extends IEntityManagerProps<ICustomerEquipmentModel> {

}

interface ICustomerEquipmentModelListStates extends IEntityManagerStates<ICustomerEquipmentModel> {
    
}

export class CustomerEquipmentModelList extends BaseEntityManager<ICustomerEquipmentModel, ICustomerEquipmentModelListProps, ICustomerEquipmentModelListStates, IFetchingInfo, IInitialData> {
    static initMetadata = (): IMetadata => {
        return {
            name: "CustomerEquipmentModel",
            title: "دستگاه های ثبت شده",
            Properties: [
                {
                    title: "سریال تجهیز",
                    dataIndex: "EquipmentSerialNo",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    disabled: false,
                    filterable: true,
                    width: 150
                },
                {
                    title: "تجهیز",
                    dataIndex: "Equipment.Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "برند",
                    dataIndex: "BrandTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    disabled: true,
                    width: 150
                },
                {
                    title: "مدل تجهیز",
                    dataIndex: "EquipmentModelTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "بیمه گزار/مشتری",
                    dataIndex: "Customer.FullName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: false,
                    sortable: false,
                    disabled: true,
                    width: 150
                },
                {
                    title: "کد ملی بیمه گزار/مشتری",
                    dataIndex: "Customer.NationalCode",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    disabled: true,
                    width: 150
                }
            ]
        };
    }

    onInitializing() {
        this.baseUrl = "portal";
        this.getUrl = "portal/CustomerEquipmentModelList";
        this.getInitialDataUrl = "portal/GetCustomerEquipmentModelListInitialData";

        this.searchable = true;
        this.searchArea = {
            columnsPerRow: 2
        };
    }
}